'use client';

import { SpeedInsights } from '@vercel/speed-insights/next';
import { PropsWithChildren } from 'react';

import { CommonProviders } from '../../lib/router/CommonProviders';

const Layout = ({ children }: PropsWithChildren) => (
	<>
		<CommonProviders>{children}</CommonProviders>

		{/* See: https://vercel.com/docs/speed-insights/quickstart */}
		{/* Adding SpeedInsights to the root layout causes a hydration error */}
		<SpeedInsights />
	</>
);

export default Layout;
